module.exports = __webpack_public_path__ + "media/components/assets/img/icons/airplane-negative-9c42169abbacae6f132f147224acd324.svg";